import Icon from "src/components/Icon";
import ilustraOnboarding03 from "src/global/assets/ilustrations/ilustra-white-onboarding-03.svg";
import Text from "src/components/Text";
import { BUTTON_TEXT, SUBTITLE, TITLE } from "src/components/StoresPromosComponent/ApplicationPromoSent/constants";
import GenericActionButton from "src/components/GenericActionButton";

import { styles } from "./styles";

const ApplicationPromoSent = () => {
  const { classes } = styles();

  return (
    <div className={classes.container}>
      <div className={classes.componentContainer}>
        <Icon source={ilustraOnboarding03} size={175} />
        <Text variant={'H1-Bold'} textAlign={"center"}>
          {TITLE}
        </Text>
        <Text variant={'H2-Regular'} textAlign={"center"}>
          {SUBTITLE}
        </Text>
        <GenericActionButton
          className={classes.button}
          label={BUTTON_TEXT}
          type='button'
          testId={'submit-button'}
          href={'/transactions'}
        />
      </div>
    </div>
  );
};

export default ApplicationPromoSent;